module.exports = __webpack_public_path__ + "static/media/last_getty_tablet.6f9c3bfb.jpg";